/*/ ## EF.Collections.ActionPlanItemsCollection
//
*/
(function(EF, undefined) {

  var ActionPlanItemsCollection = Backbone.Collection.extend({ });

  _.extend(EF.Collections, {
    ActionPlanItemsCollection: ActionPlanItemsCollection
  });

})(EF);
